import * as React from 'react';

const StarListerBadge72 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 72 72", width: 72, height: 72, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M72 36c0 19.881-16.117 36-36 36C16.119 72 0 55.881 0 36 0 16.117 16.119 0 36 0c19.883 0 36 16.117 36 36Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "m30.648 42.625-7.704-2.565-2.569-7.71c-.6-1.8-3.149-1.8-3.75 0l-2.568 7.71-7.708 2.565c-1.799.601-1.799 3.149 0 3.75l7.708 2.565 2.569 7.71c.6 1.8 3.148 1.8 3.75 0l2.567-7.71 7.705-2.565c1.802-.601 1.802-3.149 0-3.75Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M25.508 50.934h27.094a2.912 2.912 0 0 0 2.909-2.91c0-1.11-.616-2.104-1.608-2.602L36.21 36.575l-5.69 2.845-4.572-1.522 8.565-4.281.002-3.25c.003-1.637 1.14-3.018 2.764-3.36 2.7-.57 4.44-3.177 3.958-5.932-.359-2.044-2.034-3.724-4.078-4.083-1.54-.275-3.046.116-4.224 1.106a5.099 5.099 0 0 0-1.826 3.915h-3.406a8.497 8.497 0 0 1 3.043-6.524 8.532 8.532 0 0 1 7.005-1.853c3.427.604 6.24 3.422 6.842 6.851.797 4.574-2.105 8.902-6.61 9.853l-.059 3.284 17.504 8.752a6.315 6.315 0 0 1-2.825 11.965H24.339l1.17-3.407Zm36.816-27.121-3.852-1.283-1.284-3.856c-.3-.899-1.575-.899-1.875 0l-1.284 3.856-3.854 1.283c-.9.3-.9 1.574 0 1.874l3.854 1.283 1.284 3.856c.3.899 1.574.899 1.875 0l1.284-3.856 3.852-1.283c.901-.3.901-1.574 0-1.874Z"
  }
));
StarListerBadge72.Size = 72;
StarListerBadge72.Title = "StarListerBadge";

export { StarListerBadge72 as default };
